import { com } from '@eidu/web'
import formsBaseUrl from './baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import formContentIdFromString = com.eidu.entity.form.formContentIdFromString
import FormContentIdAndHash from '../../../domain/form/FormContentIdAndHash'
import FormContent = com.eidu.sharedlib.form.FormContent
import encodeCreateFormContentRequestToJson = com.eidu.sharedlib.form.encodeCreateFormContentRequestToJson
import CreateFormContentRequest = com.eidu.sharedlib.form.CreateFormContentRequest

type PostFormContentParameters = {
  formId: String
  content: FormContent
}

const postFormContent = async ({ formId, content }: PostFormContentParameters): Promise<FormContentIdAndHash> => {
  const requestBody = new CreateFormContentRequest(content)
  const response = await fetchAuthorized(
    (authContext) => `${formsBaseUrl}/organizations/${authContext.organizationId}/forms/${formId}/contents`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: encodeCreateFormContentRequestToJson(requestBody),
    }
  )
  const responseJson = await response.json()
  if (response.status !== 200 && responseJson) throw Error(responseJson.message)

  return { contentId: formContentIdFromString(responseJson.contentId), contentSha256: responseJson.contentSha256 }
}

export default postFormContent
